import { SETTINGS } from 'constants/api';
import axios from 'utils/axios';

export const getSettings = async (data = {}) => {
    const result = await axios.get(SETTINGS.v2.fetchSettings, {
        params: data
    });
    return result.data;
};

export const updateSettings = async (data = {}) => {
    const result = await axios.put(SETTINGS.v2.updateSettings, data);
    return result.data;
};

export const updateDirectLinksStatus = async (data = {}) => {
    const result = await axios.patch(SETTINGS.v2.updateDirectLinksStatus, data);
    return result.data;
};

export const updateDefaultQuizLevel = async (data = {}) => {
    const result = await axios.patch(SETTINGS.v2.updateDefaultQuizLevel, data);
    return result.data;
};

export const updateAutoIncludeCourseReady = async (data = {}) => {
    const result = await axios.patch(SETTINGS.v2.updateAutoIncludeCourseReady, data);
    return result.data;
};

export const updateOrganisationalImage = async (formData) => {
    const result = await axios.put(SETTINGS.v2.updateLogo, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return result.data;
};

export const getSubscriptionList = async (data = {}) => {
    const result = await axios.get(SETTINGS.v2.fetchSubscriptionList, {
        params: data
    });
    return result.data;
};

export const getCurrentSubscription = async (data = {}) => {
    const result = await axios.get(SETTINGS.v2.fetchCurrentSubscription, {
        params: data
    });
    return result.data;
};

export const editNotification = async (data) => {
    const result = await axios.put(SETTINGS.v2.updateNotification, data);
    return result.data;
};

export const editLearnerForm = async (data) => {
    const result = await axios.put(SETTINGS.v2.updateLearnerForm, data);
    return result.data;
};

export const editeEmailTemplate = async (data) => {
    const result = await axios.put(SETTINGS.v2.updateEmailTemplate, data);
    return result.data;
};

export const editAxcelerate = async (data) => {
    const result = await axios.put(SETTINGS.v2.updateAxcelerate, data);
    return result.data;
};

export const testAxcelerate = async (data) => {
    const result = await axios.post(SETTINGS.v2.testAxcelerate, data);
    return result.data;
};

export const editApiEnabled = async (data) => {
    const result = await axios.put(SETTINGS.v2.updateApiEnabled, data);
    return result.data;
};

export const editWisenetEnabled = async (data) => {
    const result = await axios.put(SETTINGS.v2.updateWisenetEnabled, data);
    return result.data;
};

export const editWebhooks = async (data) => {
    const result = await axios.post(SETTINGS.v2.updateWebhooks, data);
    return result.data;
};
